import React from "react";
const decode = require('decode-html');

const Teaser = (props) => {
	const {
		// eslint-disable-next-line no-unused-vars
		guid,
		dateFrom = false,
		dateTo = false,
		category = false,
		location = false,
		headline,
		text,
		url,
		labelReadMore = "Weiterlesen",
	} = props;

	const hasCategory = category !== false;
	let dateString = (dateFrom) ? dateFrom : '';
	if (dateFrom && dateTo) {
		dateString = dateFrom + ' - ' + dateTo; 
	}

	return (
		<article className="pt-react-teaserlist-teaser">
			<a href={ url }>
				<div className="teaser-content">
					<div className="teaser-meta">
						{ dateString &&
						<p className="meta-date">{ dateString }</p>
						}
						{ location &&
						<p className="meta-location">{ location }</p>
						}
						{ hasCategory &&
						<p className="meta-type">{ category }</p>
						}
					</div>
					<h3 dangerouslySetInnerHTML={ { __html: decode(headline) } } />
					<p dangerouslySetInnerHTML={ { __html: decode(text) } } />
					<p className="readmore-wrap"><span className="icon-link">{ labelReadMore }</span></p>
				</div>
			</a>
		</article>
	);
};

export default Teaser;
